/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_Plan_CreatePlanTerminationRulesRequestDto } from '../models/Wealthlane_AwardService_Dtos_Plan_CreatePlanTerminationRulesRequestDto';
import type { Wealthlane_AwardService_Dtos_Plan_CreatePlanTerminationRulesResponseDto } from '../models/Wealthlane_AwardService_Dtos_Plan_CreatePlanTerminationRulesResponseDto';
import type { Wealthlane_AwardService_Dtos_Plan_TerminationRuleItemDto } from '../models/Wealthlane_AwardService_Dtos_Plan_TerminationRuleItemDto';
import type { Wealthlane_AwardService_Dtos_Response_ResponseDto } from '../models/Wealthlane_AwardService_Dtos_Response_ResponseDto';
import type { Wealthlane_AwardService_Dtos_TerminationDto_UpdateEntityTerminationRuleSetDto } from '../models/Wealthlane_AwardService_Dtos_TerminationDto_UpdateEntityTerminationRuleSetDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TerminationRuleService {

    /**
     * @param requestBody 
     * @returns string OK
     * @throws ApiError
     */
    public static postApiAwardApiAppTerminationRuleTerminationRules(
requestBody?: Array<Wealthlane_AwardService_Dtos_Plan_TerminationRuleItemDto>,
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/termination-rule/termination-rules',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns boolean OK
     * @throws ApiError
     */
    public static putApiAwardApiAppTerminationRuleTerminationRule(
requestBody?: Array<Wealthlane_AwardService_Dtos_Plan_TerminationRuleItemDto>,
): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/termination-rule/termination-rule',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param planId 
     * @returns Wealthlane_AwardService_Dtos_Plan_TerminationRuleItemDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppTerminationRuleTerminationRuleByPlanId(
planId: string,
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Plan_TerminationRuleItemDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/termination-rule/termination-rule-by-plan-id/{planId}',
            path: {
                'planId': planId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param terminationRuleSetId 
     * @returns Wealthlane_AwardService_Dtos_Plan_TerminationRuleItemDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppTerminationRuleTerminationRuleBySetId(
terminationRuleSetId: string,
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Plan_TerminationRuleItemDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/termination-rule/termination-rule-by-set-id/{terminationRuleSetId}',
            path: {
                'terminationRuleSetId': terminationRuleSetId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static putApiAwardApiAppTerminationRuleAwardTerminationRuleByAwardId(
requestBody?: Array<Wealthlane_AwardService_Dtos_TerminationDto_UpdateEntityTerminationRuleSetDto>,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/termination-rule/award-termination-rule-by-award-id',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param awardId 
     * @param awardType 
     * @returns Wealthlane_AwardService_Dtos_Plan_TerminationRuleItemDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppTerminationRuleTerminationRuleByAwardId(
awardId: string,
awardType?: string,
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Plan_TerminationRuleItemDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/termination-rule/termination-rule-by-award-id/{awardId}',
            path: {
                'awardId': awardId,
            },
            query: {
                'awardType': awardType,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static putApiAwardApiAppTerminationRuleGrantTerminationRuleByGrantId(
requestBody?: Array<Wealthlane_AwardService_Dtos_TerminationDto_UpdateEntityTerminationRuleSetDto>,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/termination-rule/grant-termination-rule-by-grant-id',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static putApiAwardApiAppTerminationRuleParticipantTerminationRuleByParticipantId(
requestBody?: Array<Wealthlane_AwardService_Dtos_TerminationDto_UpdateEntityTerminationRuleSetDto>,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/termination-rule/participant-termination-rule-by-participant-id',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param participantId 
     * @returns Wealthlane_AwardService_Dtos_Plan_TerminationRuleItemDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppTerminationRuleParticipantTerminationRules(
participantId: string,
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Plan_TerminationRuleItemDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/termination-rule/participant-termination-rules/{ParticipantId}',
            path: {
                'ParticipantId': participantId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param grantId 
     * @returns Wealthlane_AwardService_Dtos_Plan_TerminationRuleItemDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppTerminationRuleGrantTerminationRules(
grantId: string,
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Plan_TerminationRuleItemDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/termination-rule/grant-termination-rules/{GrantId}',
            path: {
                'GrantId': grantId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Plan_CreatePlanTerminationRulesResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppTerminationRulePlanTerminationRules(
requestBody?: Wealthlane_AwardService_Dtos_Plan_CreatePlanTerminationRulesRequestDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_Plan_CreatePlanTerminationRulesResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/termination-rule/plan-termination-rules',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
